import './index.scss';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button } from '@sharedComponents/DesignSystem/Inputs';
import { translate } from '@utils';
import { Paths } from '@constants/paths';
import notFound from '@images/not-found.png';
import { canAllowLettersPageSelector } from '@selectors/app';

export const NotFound = () => {
  const canAllowLettersPage = useSelector(canAllowLettersPageSelector);
  const navigate = useNavigate();

  const goToMainPage = () => {
    navigate(`${Paths.LETTERS}`);
  };

  return (
    <div className="error__container">
      <img alt="not-found-image" src={notFound} />
      <div className="error__content">
        <h1>{translate('error')} 404</h1>
        {translate('page_not_found')}
      </div>
      {canAllowLettersPage && (
        <Button type="stroke" onClick={goToMainPage}>
          {translate('go_back')}
        </Button>
      )}
    </div>
  );
};
